import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || "pt";

  const footerLinks = [
    {
      title: "CSSBuy Spreadsheet",
      links: [
        { label: t("nav.spreadsheet"), href: `/${currentLang}/cssbuy-spreadsheet/` },
        { label: t("nav.guides"), href: `/${currentLang}/#articles` },
        { label: t("nav.reviews"), href: `/${currentLang}/#review` },
      ],
    },
    {
      title: "Resources",
      links: [
        { label: t("nav.shipping"), href: `/${currentLang}/#shipping` },
        { label: t("nav.qc"), href: `/${currentLang}/#qc` },
        { label: t("nav.sellers"), href: `/${currentLang}/#sellers` },
        { label: t("nav.safety"), href: `/${currentLang}/#safety` },
      ],
    },
    {
      title: "About",
      links: [
        { label: t("footer.about"), href: `/${currentLang}/#about` },
        { label: t("footer.contact"), href: `/${currentLang}/#contact` },
        { label: t("footer.editorial"), href: `/${currentLang}/#editorial` },
      ],
    },
    {
      title: "Legal",
      links: [
        { label: t("footer.privacy"), href: `/${currentLang}/#privacy` },
        { label: t("footer.terms"), href: `/${currentLang}/#terms` },
        { label: t("footer.disclaimerLink"), href: `/${currentLang}/#disclaimer` },
        { label: t("footer.safety"), href: `/${currentLang}/#safety` },
      ],
    },
  ];

  const languages = [
    { code: "pt", label: "Português" },
    { code: "de", label: "Deutsch" },
    { code: "en", label: "English" },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-10">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                {group.title}
              </h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/50 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              {languages.map((l) => (
                <a
                  key={l.code}
                  href={`/${l.code}/`}
                  className={`text-sm transition-colors ${
                    currentLang === l.code
                      ? "text-primary-600 font-medium"
                      : "text-foreground-500 hover:text-foreground-700"
                  }`}
                >
                  {l.label}
                </a>
              ))}
            </div>
            <p className="text-xs text-foreground-500 text-center md:text-right">
              {t("footer.copyright")}
            </p>
          </div>
        </div>

        <div className="mt-6 p-4 bg-background-200/50 rounded-lg">
          <p className="text-xs text-foreground-500 text-center leading-relaxed">
            {t("footer.disclaimer")}
          </p>
        </div>
      </div>
    </footer>
  );
}